<template>
  <div>
    <h1 class="mb-8 font-bold text-2xl">LISTE POSTES ENVOYÉS</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="mt-4 block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null"/>
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>

    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
          <th class="px-2 pt-6 pb-4">N° Order</th>
          <th class="px-2 pt-6 pb-4">N° Envoi</th>
          <th class="px-2 pt-6 pb-4">IMEI</th>
          <th class="px-6 pt-6 pb-4">Brand</th>
          <th class="px-6 pt-6 pb-4">Model</th>
          <th class="px-6 pt-6 pb-4">Agence</th>
          <th class="px-6 pt-6 pb-4">Envoyé par</th>
          <th class="px-6 pt-6 pb-4">Imprimer</th>
        </tr>
        <tr v-for="repair in repairs.data" :key="repair.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" href="#">
              {{ repair.id }}
              <icon v-if="repair.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2"/>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" href="#"
                          tabindex="-1">
              {{ repair.shipping_no }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" href="#"
                          tabindex="-1">
              {{ repair.imei }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" href="#"
                          tabindex="-1">
              {{ repair.brand }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" href="#"
                          tabindex="-1">
              {{ repair.model}}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" href="#"
                          tabindex="-1">
              {{ repair.agency }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" href="#"
                          tabindex="-1">
              {{ repair.agent }}
            </inertia-link>
          </td>
          <td class="border-t">
            <span class="cursor-pointer" title="Imprimer le Bordereaux D'expedition" @click="printBl([repair.id])">
              <svg class="h-10 w-10 mx-auto text-green-600 hover:text-green-800" xmlns="http://www.w3.org/2000/svg" fill="none"
                   viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/>
              </svg>
            </span>
          </td>
        </tr>
        <tr v-if="repairs.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No reparation found.</td>
        </tr>
      </table>
    </div>
    <pagination :links="repairs.links"/>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";

export default {
  metaInfo: {title: 'Reception poste'},
  layout: Layout,
  components: {
    Icon,
    SearchFilter,
    Pagination,
  },
  props: {
    repairs: Object,
    filters: Object,
  },
  data() {
    return {
      selected: [],
      selectAll: false,
      sending: false,
      form: {},
    }
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('shipment.shipped', Object.keys(query).length ? query : {remember: 'forget'}))
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    printBl(ids) {
      window.open(this.route('shipment.generateBl', ids.join()), "_blank");
    },
  },
}
</script>
